import { Person } from '@/quote/domain/Person';

interface QuoteConstructor {
  type: string;
  zip_code: number;
  applicants: Array<Person> ;
  county: string;
  effective_date: number;
  isSenior?: boolean;
}
export interface QuotePrimitives {
  type: string;
  zip_code: number;
  applicants: Array<Person> ;
  county: string;
  isSenior?: boolean;
  effective_date: number;
}

export class Quote {

  public type: string;
  public zip_code: number;
  public applicants: Array<Person>;
  public county: string;
  public effective_date: number;
  public isSenior?: boolean;

  public constructor ({ type, zip_code, applicants, county, effective_date, isSenior }: QuoteConstructor) {
    this.type = type;
    this.zip_code = zip_code;
    this.applicants = applicants;
    this.county = county;
    this.effective_date = effective_date;
    this.isSenior = isSenior;
  }

  public getType (): string {
    return this.type;
  }

  public getZipcode (): number {
    return this.zip_code;
  }

  public static fromPrimitives (quotePrimitives: QuotePrimitives): Quote {
    const quote: QuoteConstructor = {
      ...quotePrimitives,
      zip_code: quotePrimitives.zip_code
    };

    return new Quote(quote);
  }

}
